// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressAutofillController from "./address_autofill_controller"
application.register("address-autofill", AddressAutofillController)

import AdminSearchController from "./admin_search_controller"
application.register("admin-search", AdminSearchController)

import CheckboxFilterController from "./checkbox_filter_controller"
application.register("checkbox-filter", CheckboxFilterController)

import RevealOnChangeController from "./reveal_on_change_controller"
application.register("reveal-on-change", RevealOnChangeController)

import SearchShortcutController from "./search_shortcut_controller"
application.register("search-shortcut", SearchShortcutController)

import TimesheetGridController from "./timesheet_grid_controller"
application.register("timesheet-grid", TimesheetGridController)
